import { useEffect } from 'react';
import { useData } from '../context/DataContext';
import AutoScroller from '../components/AutoScroller';

export default function AboutPage() {
  const { data, loading } = useData();

  useEffect(() => {
    document.body.classList.add('page-about');
    return () => document.body.classList.remove('page-about');
  }, []);

  useEffect(() => {
    if (data) {
      document.title = data.pages?.about?.meta?.title || 'About — Preeyanka Mondal';
    }
  }, [data]);

  if (loading || !data) return null;

  const page = data.pages?.about || {};
  const hero = page.hero || {};
  const photo = page.photo || {};
  const sections = page.sections || {};
  const whatIdo = sections.whatIdo || {};
  const background = sections.background || {};
  const contact = sections.contact || {};
  const brands = page.brands || [];
  const agencies = page.agencies || [];
  const sectionTitles = page.sectionTitles || {};

  // Deduplicate logos by name for display
  const uniqueBrands = brands.filter((b, i, arr) => arr.findIndex(x => x.name === b.name) === i);
  const uniqueAgencies = agencies.filter((a, i, arr) => arr.findIndex(x => x.name === a.name) === i);

  const brandRow1 = uniqueBrands.filter((_, i) => i % 2 === 0);
  const brandRow2 = uniqueBrands.filter((_, i) => i % 2 !== 0);

  return (
    <div className="wrap">
      <main className="about-page" aria-label="About page">
        {/* About split */}
        <section className="about-split" aria-label="About intro">
          <div className="about-left">
            <h1 className="about-title">{hero.title}</h1>
            <p className="about-subtitle">{hero.subtitle}</p>

            <div className="about-body">
              {/* What I do */}
              {whatIdo.heading && (
                <div className="about-block">
                  <h3>{whatIdo.heading}</h3>
                  {(whatIdo.items || []).map((item, i) => (
                    <p key={i}>
                      <strong>{item.title}</strong>
                      {item.subtitle && <><br /><span style={{ color: 'var(--muted)', fontStyle: 'italic' }}>{item.subtitle}</span></>}
                    </p>
                  ))}
                </div>
              )}

              {/* Background */}
              {background.heading && (
                <div className="about-block">
                  <h3>{background.heading}</h3>
                  <p>{background.text}</p>
                </div>
              )}

              {/* Contact */}
              {contact.heading && (
                <div className="about-block">
                  <h3>{contact.heading}</h3>
                  <p>
                    {contact.text}
                    {contact.email && (
                      <a href={`mailto:${contact.email}`} style={{ color: 'var(--accent)' }}>
                        {contact.email}
                      </a>
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>

          <aside className="about-right" aria-label="About photo">
            <div className="about-photo">
              <img src={photo.image} alt={photo.alt || 'Portrait'} />
            </div>
          </aside>
        </section>

        {/* Brands - two rows scrollable */}
<section className="logo-section" aria-label="Brands I have worked with">
  <h2 className="logo-title">{sectionTitles.brands || "Brands I've worked with"}</h2>

  <div className="logo-scroller-stack" role="region" aria-label="Brands scroller">
    <AutoScroller
      items={brandRow1}
      rowClass="brands-row about-brands-row"
      itemRenderer={(item, key) => (
        <div className="logo-item" title={item.name} key={key} style={{ flexShrink: 0 }}>
          <img loading="lazy" decoding="async" src={item.logo} alt={item.name} />
        </div>
      )}
    />

    <AutoScroller
      items={brandRow2}
      rowClass="brands-row about-brands-row"
      itemRenderer={(item, key) => (
        <div className="logo-item" title={item.name} key={key} style={{ flexShrink: 0 }}>
          <img loading="lazy" decoding="async" src={item.logo} alt={item.name} />
        </div>
      )}
    />
  </div>
</section>

        {/* Agencies - one row scrollable */}
<section className="logo-section" aria-label="Agencies I have worked with">
  <h2 className="logo-title">{sectionTitles.agencies || "Agencies I've worked with"}</h2>

  <AutoScroller
    items={uniqueAgencies}
    rowClass="brands-row about-brands-row"
    itemRenderer={(item, key) => (
      <div className="logo-item" title={item.name} key={key} style={{ flexShrink: 0 }}>
        <img loading="lazy" decoding="async" src={item.logo} alt={item.name} />
      </div>
    )}
  />
</section>
      </main>
    </div>
  );
}
